import { useMutation, useQueryClient } from '@tanstack/react-query';

import { replaceDocumentContent } from '../services/api/documents';

type ReplacePayload = {
  id: string;
  file: File;
};

export const useDocumentReplace = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, file }: ReplacePayload) => replaceDocumentContent(id, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
};
